import React, { useEffect, useState, useRef } from "react";
import $, { data } from "jquery";
import axios from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import EditDesignation from "../../components/Modals/Settings/EditDesignation";
import AddDesignation from "../../components/Modals/Settings/AddDesignation";

function DesignationsList() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [selectedDesignationId, setSelectedDesignationId] = useState(null);
  const [options, setoptions] = useState([]);
  const [EditModel, setEditModel] = useState(false);
  const [AddModel, setAddModel] = useState(false);
  const fetchOptions = async () => {
    setGlobalLoading(true); //  Show loader before API call
    try {
      const response = await axios.get(
        `${API_BASE_URL}/settings/get_designations_list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setoptions(response.data.designations || []);
    } catch (error) {
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

useEffect(() => {
    if (options.length > 0) return;
    fetchOptions();
}, []);

  const OpenEditDesignationModal = (id) => {
    setSelectedDesignationId(id);
    setEditModel(true);
  };

 const OpenAddDesignationModel = () => {
    setAddModel(true);
  };

 const columns = [
    {
      accessorKey: "id",
      header: "ID",
      size: 80,
      Cell: ({ row }) => {
              return (
                <div className="d-flex align-items-center file-name-icon">
                    <a href="javascript:void(0)" onClick={() => OpenEditDesignationModal(row.original.id)} title="Edit User">
                    <div className="ms-2">
                      <h6 className="fw-medium mb-0">{row.original.id}</h6>
                    </div>
                    </a>
                </div>
              );
            },
    },{
      accessorKey: "name",
      header: "Designation Name",
      size: 150,
        Cell: ({ row }) => (
          <a
            href="javascript:void(0)"
            onClick={() => OpenEditDesignationModal(row.original.id)}
            title="Edit Designation"
            style={{ cursor: "pointer", fontWeight: "bold", color: "#000000ff", textDecoration: "none" }}
          >
            {row.original.name}
          </a>
        ),
      },{
      accessorKey: "details",
      header: "Details",
      size: 250,
    },{
      accessorKey: "sub_department_name",
      header: "Sub Department",
      size: 140,
    },
  ];

    return (
    <>
     <div className="content">
		<div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
			<div className="my-auto mb-2">
				<h2 className="mb-1">All Modules</h2>
			</div>
      <div className="d-flex list-group-horizontal border-0">
          <button className="btn btn-primary ms-2" title="Add Module" type="button" onClick={() => OpenAddDesignationModel(true)}>
              <i className="fa-solid fa-plus me-1"></i>
              Add Designation
          </button>
          {AddModel && (
              <AddDesignation
                onClose={(data) => {
                  setAddModel(false);
                }}
              />
            )}
      </div>
		</div>
		<div className="card">
		    <div className="card-body p-0">
				<div className="custom-datatable-filter table-responsive">
					<MaterialReactTable
						columns={columns}
						data={options}
						initialState={{	pagination: { pageSize: 200 },}}
						muiTableBodyRowProps={{sx: {height: "20px"},}}
						muiTableBodyCellProps={{sx: {padding: "2px 4px"},}}
						muiTableHeadCellProps={{sx: {padding: "2px 4px", height: "30px"},}}
					/>;
				</div>
			</div>
		</div>
        {EditModel && (
        <EditDesignation
          id={selectedDesignationId}
          onClose={() => {
            setEditModel(false);
            fetchOptions();
          }}
        />
      )}
     </div>   
    </>
  )

}

export default DesignationsList